import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Radio } from 'antd';
import './CandidateSortingFilter.scss';
import message from './CandidateSortingFilterMessage';

const RadioGroup = Radio.Group;

export default class CandidateSortingFilter extends React.Component {
  constructor(props) {
    super(props);
  }

  onChange = event => {
    const { applySortingFilter, activeTab, setSelectedFilter } = this.props;
    const appliedFilter = event.target.value;
    setSelectedFilter(appliedFilter);
    const sanitisedSortByFilter = activeTab !== 'ranked' && appliedFilter === 'Latest' ? 'Date' : appliedFilter;
    applySortingFilter(sanitisedSortByFilter);
  };

  render() {
    const { selectedFilter } = this.props;
    const sortingTypeToText = {
      Ranking: <FormattedMessage {...message.rankingLabel} />,
      Relevance: <FormattedMessage {...message.relevenceLabel} />,
      Latest: <FormattedMessage {...message.latestLabel} />,
    };

    return (
      <div className="sorting-filter">
        <div className="sortingfilter-sortby-clear">
          <div className="sortingfilter-sortby">
            <FormattedMessage {...message.sortByLabel} />
          </div>
        </div>
        <div>
          <RadioGroup onChange={this.onChange} value={selectedFilter}>
            {Object.keys(sortingTypeToText).map(sortingType => (
              <div className="candidate-sorting-radio-div" key={sortingType}>
                <Radio className="candidate-sorting-radio" value={sortingType}>
                  {sortingTypeToText[sortingType]}
                </Radio>
              </div>
            ))}
          </RadioGroup>
        </div>
      </div>
    );
  }
}
